export const SPORT_TIME_FILTERS = [
  {
    value: 10,
    label: "1",
    tranlation: "hour",
  },
  {
    value: 20,
    label: "3",
    tranlation: "hours",
  },
  {
    value: 30,
    label: "",
    tranlation: "today",
  },
  {
    value: 40,
    label: "48",
    tranlation: "hours",
  },
  {
    value: 50,
    label: "",
    tranlation: "allFilter",
  },
];

export const SPORT_PRINT_ODD_DATE_OPTIONS = [
  { label: "all", value: "All" },
  { label: "This week", value: "thisWeek" },
  { label: "Next week", value: "nextWeek" },
  { label: "Today", value: "today" },
  { label: "Today +1", value: "today +1" },
  { label: "Today +2", value: "today +2" },
];

export const SPORT_WIDGET_TABS = [
  { label: "topLeague", value: "topleague" },
  { label: "mostPlayed", value: "mostplayed" },
  { label: "lastMinutes", value: "lastminutes" },
];

export const SPORTS_FILTERS = [
  {
    type: "favourites",
    label: "Top Leagues",
    iconName: "trophy-star",
  },
  {
    type: "featured",
    label: "Featured",
    iconName: "star",
  },
];

export const BINDING_LEGENDS = [
  { value: 0, label: "unique" },
  { value: 1, label: "single" },
  { value: 3, label: "triple" },
  { value: 5, label: "quintuple" },
];

export const SKIN_WITHOUT_BANNERS_IN_COUPON = ["planeth24"];

export const SPORT_TOURNAMENT_EVENT_IN_ROW = ["planeth24"];
export const SPORT_EVENT_NO_MARKET_COUNT = ["planeth24"];
export const SPORT_CHILDREN_LENGTH = ["vskin"];
export const SPORT_EVENT_INTERVAL_TIMING = 120000;
export const SPORT_TOURNAMENT_INTERVAL_TIMING = 120000;
